import HorsesList from './HorsesList';

export default HorsesList;
